import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { EmployerProfileResponse } from '../../core/models/employer/employer-profile-response';
import { EmployerService } from '../../core/services/v2/employer.service';
import { UserService } from '../../core/services/v2/user.service';
import { UtilsService } from '../../core/services/v2/utils.service';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-employer-profile',
  templateUrl: './employer-profile.component.html',
  styleUrls: ['./employer-profile.component.scss']
})
export class EmployerProfileComponent implements OnInit {
  @Input() employerDetails: any;
  @Input() editEnable: boolean = false;
  showBanner: boolean = true;
  showLocations: boolean = true;
  showEditInfo: boolean = false;
  showAddInfo: boolean = false;
  showAddLocation: boolean = false;
  showEditLocation: boolean = false;
  userId: number;
  employerId: number;
  businessName: string;
  tagLine: string;
  industry: string;
  employerData: EmployerProfileResponse;
  employerLocations: any;
  employerProfileForm: FormGroup = this.fb.group({
    id: [''],
    employerId: [''],
    employerName: [''],
    employerLogoUrl: [''],
    employerLogoBlob: [''],
    employerTagLine: [''],
    employerIndustry: ['']
  });
  locationForm: FormGroup;
  contactSection: string;
  logoName: string;
  modalTitle: string;
  contactPersonForm: FormGroup = this.fb.group({
    id: [''],
    emailAddress: ['', [Validators.required, Validators.email]],
    faxNumber: [''],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    middleName: ['', Validators.required],
    prefix: ['', Validators.required],
    primaryPhoneNumber: ['', Validators.required],
    professionalTitle: ['', Validators.required],
    secondaryPhoneNumber: [''],
    suffix: ['', Validators.required],
  });

  constructor(private userService: UserService,
    private employerService: EmployerService,
    private fb: FormBuilder,
    private loader: WindowLoaderService,
    private utils: UtilsService) {  this.setLocationFormControl(); // Initialize with default values or fetched data.
    }

  ngOnInit() {
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.userId = userDetails.id;
        this.employerId = userDetails.employerId
        console.log("This is userId: ", this.userId);
        console.log("This is empId: ", this.employerId);

        this.getEmployerProfileData();
      },
      (error) => { console.error(error); }
    );

  }

  showEditInfoTab() {
    this.employerProfileForm.reset();
    this.showAddInfo = true;
    this.showBanner = false;
    this.showLocations = false;
    this.employerProfileForm.controls.employerName.setValue(this.employerData.employerName);
    this.employerProfileForm.controls.employerLogoUrl.setValue(this.employerData.employerLogoUrl);
    this.employerProfileForm.controls.employerTagLine.setValue(this.employerData.employerTagLine);
    this.employerProfileForm.controls.employerIndustry.setValue(this.employerData.employerIndustry);
  }

  hideEditInfoTab() {
    this.showAddInfo = false;
    this.showBanner = true;
    this.showLocations = true;
  }

  editLocationTab(locationData: any = null) {
    console.log("edit location data",locationData);
    this.showAddLocation = true;
    this.showBanner = false;
    this.showLocations = false;
    this.showEditInfo = false;
    this.showAddInfo = false;
    //this.locationForm.reset();
    if (locationData) {
      this.bindLocationForm(locationData);
    }
  }

  bindLocationForm(locationData: any) {
    this.setLocationFormControl(locationData);
    this.locationForm.patchValue(locationData);
  }

  addLocationTab() {
    this.setLocationFormControl();
    this.locationForm.reset();
    this.showAddLocation = true;
    this.showBanner = false;
    this.showLocations = false;
    this.showEditInfo = false;
    this.showAddInfo = false;
  }

  setLocationFormControl(locationData: any = null) {
    this.locationForm = this.fb.group({
      id: [''],
      employerId: [''],
      employerBasicDetails: this.fb.group({
        addressLine1: ['', Validators.required],
        addressLine2: ['', Validators.required],
        city: ['', Validators.required],
        country: ['', Validators.required],
        companyName: ['', Validators.required],
        corporateWebsite: [''],
        email: ['', [Validators.required, Validators.email]],
        fax: ['', Validators.required],
        locationType: ['', Validators.required],
        primaryPhone: ['', Validators.required],
        secondaryPhone: [''],
        state: ['', Validators.required],
        zip: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("^[0-9]*$")]],
        workingHrs: new FormArray(
          locationData ? locationData.employerBasicDetails.workingHrs.map((workings) => {
            return this.fb.group({
              day: workings.day,
              timeFrom: [''],
              timeTo: ['']
            });
          })
            :
            [this.fb.group({
              day: [''],
              timeFrom: [''],
              timeTo: ['']
            })]
        ),
      }),
      employerBenifitAgents: [''],
      employerCallCenterCoordinator: [''],
      employerHealthBenifitDetails: [''],
      employerHrContactDetails: ['']
    });
  }

  hideLocationTab() {
    console.log("hideLocationTab called");

    this.showAddLocation = false;
    this.showEditLocation = false;
    this.showBanner = true;
    this.showLocations = true;
  }

  getEmployerProfileData(): void {
    this.loader.blockWithLoader(this.employerService.getEmployerProfileDetails(this.employerId)).subscribe(
      (data) => {
        if (data) {
          console.log("data",data)
          this.employerData = data;
          this.formatEmployerLocations();
          console.log(this.employerData);
        }
      },
      (error) => { console.error(error); },
    )
  }

  attachLogo(event: any) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (!file.type.includes("image")) {
        alert('Please attach only Image file');
        return;
      }
      this.logoName = file.name;
      this.employerProfileForm.get('employerLogoBlob').setValue(file);
    }
  }

  saveEmployerProfileData() {
    const formData = this.employerProfileForm.getRawValue();
    const obj: FormData = new FormData();
    obj.append("Id", this.employerData.id.toString());
    obj.append("EINNumber", this.employerData.einNumber.toString());
    obj.append("EmployerName", formData.employerName);
    obj.append("EmployerLogoUrl", formData.employerLogoUrl);
    obj.append("EmployerTagLine", formData.employerTagLine);
    obj.append("EmployerIndustry", formData.employerIndustry);
    obj.append("EmployerLogo", this.employerProfileForm.get('employerLogoBlob').value);

    this.loader.blockWithLoader(this.employerService.updatemployerProfileDetails(obj)).subscribe(
      (res) => {
        if (res.isSuccess) {
          this.hideEditInfoTab();
          this.getEmployerProfileData();
        }
      },
      (error) => { console.error(error); },
    )
  }

  formatEmployerLocations() {
    if (this.employerData && this.employerData.employerLocations) {
      this.employerLocations = [];
      this.employerData.employerLocations.forEach((item) => {
        const employerBasicDetails = JSON.parse(item.employerBasicDetails);
        const employerBenifitAgents = JSON.parse(item.employerBenifitAgents);
        const employerCallCenterCoordinator = JSON.parse(item.employerCallCenterCoordinator);
        const employerHealthBenifitDetails = JSON.parse(item.employerHealthBenifitDetails);
        const employerHrContactDetails = JSON.parse(item.employerHrContactDetails);
        this.employerLocations.push(
          { id: item.id, employerId: item.employerId, employerBasicDetails, employerBenifitAgents, employerCallCenterCoordinator, employerHealthBenifitDetails, employerHrContactDetails }
        );
      });
      console.log('location', this.employerLocations);
    }
  }

  addLocationSection(contactSection: string) {
    this.contactPersonForm.reset();
    this.contactSection = contactSection;
      // Update the modal title dynamically
  switch (contactSection) {
    case 'HumanResource':
      this.modalTitle = 'Human Resource Contact Information';
      break;
    case 'HealthCoordinator':
      this.modalTitle = 'Health Coordinator Contact Information';
      break;
    case 'BenefitsAgent':
      this.modalTitle = 'Benefits Agent Contact Information';
      break;
      case 'CallCenterCoordinator':
        this.modalTitle = 'CallCenterCoordinator Agent Contact Information';
        break;
      
    default:
      this.modalTitle = 'Contact Information';
  }
  }

  saveContactResouceInfo() {
    this.contactPersonForm.get('id').setValue(Math.floor(Math.random() * 100));
    const formData = this.contactPersonForm.getRawValue();
    switch (this.contactSection) {
      case 'HumanResource': {
        let val = this.locationForm.controls.employerHrContactDetails.value;
        if (val && val.length > 0) {
          val.push(formData);
          this.locationForm.controls.employerHrContactDetails.setValue(val);
        }
        else {
          this.locationForm.controls.employerHrContactDetails.setValue([formData]);
        }
        break;
      }
      case 'HealthCoordinator': {
        let val = this.locationForm.controls.employerHealthBenifitDetails.value;
        if (val && val.length > 0) {
          val.push(formData);
          this.locationForm.controls.employerHealthBenifitDetails.setValue(val);
        }
        else {
          this.locationForm.controls.employerHealthBenifitDetails.setValue([formData]);
        }
        break;
      }
      case 'BenefitsAgent': {
        let val = this.locationForm.controls.employerBenifitAgents.value;
        if (val && val.length > 0) {
          val.push(formData);
          this.locationForm.controls.employerBenifitAgents.setValue(val);
        }
        else {
          this.locationForm.controls.employerBenifitAgents.setValue([formData]);
        }
        break;
      }
      case 'CallCenterCoordinator': {
        let val = this.locationForm.controls.employerCallCenterCoordinator.value;
        if (val && val.length > 0) {
          val.push(formData);
          this.locationForm.controls.employerCallCenterCoordinator.setValue(val);
        }
        else {
          this.locationForm.controls.employerCallCenterCoordinator.setValue([formData]);
        }
        break;
      }
      default: {
        break;
      }
    }
    document.getElementById('closeModal').click();
  }


  saveLocationData(): void {
    if (this.locationForm.valid){
      const formData = this.locationForm.getRawValue();
      const locationId = formData.id ? formData.id : 0;

      const obj: FormData = new FormData();
      obj.append("Id", this.employerData.id.toString());
      obj.append("EINNumber", this.employerData.einNumber.toString());
      obj.append("EmployerName", this.employerData.employerName);
      obj.append("EmployerLogoUrl", this.employerData.employerLogoUrl);
      obj.append("EmployerTagLine", this.employerData.employerTagLine);
      obj.append("EmployerIndustry", this.employerData.employerIndustry);
      obj.append("EmployerLocation.Id", locationId);
      obj.append("EmployerLocation.EmployerId", this.employerData.id.toString());
      obj.append("EmployerLocation.EmployerBasicDetails", JSON.stringify(formData.employerBasicDetails));
      obj.append("EmployerLocation.EmployerHrContactDetails", JSON.stringify(formData.employerHrContactDetails));
      obj.append("EmployerLocation.EmployerHealthBenifitDetails", JSON.stringify(formData.employerHealthBenifitDetails));
      obj.append("EmployerLocation.EmployerBenifitAgents", JSON.stringify(formData.employerBenifitAgents));
      obj.append("EmployerLocation.EmployerCallCenterCoordinator", JSON.stringify(formData.employerCallCenterCoordinator));

      this.loader.blockWithLoader(this.employerService.updatemployerProfileDetails(obj)).subscribe(
        (res) => {
          if (res.isSuccess) {
            this.hideLocationTab();
            this.getEmployerProfileData();
          }
          // else {
          //   console.error("Save failed:", res.message);
          //   alert(`Error: ${res.message}`); // Display error message to the user
          // }
        },
        (error) => { console.error(error); },
      )

    } else {
      this.markFormFieldsAsTouched(this.locationForm);
      console.log("not valid files")
    }

  }


  private markFormFieldsAsTouched(form: FormGroup): void {
    form.markAllAsTouched();
  }

  deleteLocation(employerLocationId) {
    Swal.fire({
      title: `Remove Location`,
      text: `Are you sure want to remove this location?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Remove!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loader.blockWithLoader(this.employerService.deleteEmployerLocation(employerLocationId)).subscribe(
          (res) => {
            if (res.isSuccess) {
              this.hideLocationTab();
              this.getEmployerProfileData();
              this.utils.showMessageSnackBar('Location deleted successfully.');
            }
          },
          (error) => { console.error(error); },
        )
      }
    })


  }

  get getEmployerBasicDetails() {
    return this.locationForm.get('employerBasicDetails');
  }

  getWorkingHoursDetails(): FormArray {
    return this.locationForm.get('employerBasicDetails').get('workingHrs') as FormArray;
  }
  checkDays(i, dayName?: string) {

    let count: number = 0;
    let workingHrsArr = this.getWorkingHoursDetails();

    workingHrsArr.controls.filter((x) => x.value.day == (dayName != undefined ? dayName : workingHrsArr.controls[i].value.day)).forEach(element => {
      count++;
    });

    if (count > 1) {
      this.utils.showMessageSnackBar("Duplicate day selected!", true);
      return false;
    }
    else {
      return true;
    }
  }
  setTime(i) {
    let workingHrsArr = this.getWorkingHoursDetails();
    workingHrsArr.removeAt(i);
  }
  addNewDay() {
    let workingHrsArr = this.getWorkingHoursDetails();
    let newWorkingHrsEntry = this.fb.group({
      day: [''],
      timeFrom: [''],
      timeTo: ['']
    })
    workingHrsArr.push(newWorkingHrsEntry);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  formatTime(time: string): string {
    if (!time) return '';
    const [hours, minutes] = time.split(':').map(Number);
    const suffix = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert 0 to 12 for midnight
    return `${formattedHours}:${minutes.toString().padStart(2, '0')} ${suffix}`;
  }
}
